export const ACCOUNT_SETTINGS_PARAM = 'accountSettings';

export const ACCOUNT_SETTINGS_PANES = [
  'general',
  'notifications',
  'calendar',
  'payments',
  'security',
  'homes',
] as const;

export type AccountSettingsPaneId = (typeof ACCOUNT_SETTINGS_PANES)[number];

export function isAccountSettingsPane(value: string | null): value is AccountSettingsPaneId {
  return ACCOUNT_SETTINGS_PANES.includes(value as AccountSettingsPaneId);
}

export function withAccountSettings(
  pathname: string,
  search: string,
  pane: AccountSettingsPaneId = 'general',
): string {
  const params = new URLSearchParams(search);
  params.set(ACCOUNT_SETTINGS_PARAM, pane);
  const query = params.toString();
  return `${pathname}${query ? `?${query}` : ''}`;
}

export function withoutAccountSettings(pathname: string, search: string): string {
  const params = new URLSearchParams(search);
  params.delete(ACCOUNT_SETTINGS_PARAM);
  const query = params.toString();
  return `${pathname}${query ? `?${query}` : ''}`;
}
